import { NavItem } from 'interfaces/NavTypes';

/**
 * The API sends exactly one of the two: `translation_key` for static labels, `title`
 * for subject-backed items (articles, categories) whose title is real content.
 *
 * Static labels are deliberately not translated server-side — Laravel's __() would
 * emit the stored value verbatim, so a value using i18next nesting such as
 * $t(common.term.manage-users) would reach the navigation unresolved.
 */
export const getNavTitle = (item: NavItem, t: (key: string) => string): string => {
  if (item.translation_key) {
    return t(item.translation_key);
  }

  return item.title ?? '';
};
